import { render, staticRenderFns } from "./Badges.vue?vue&type=template&id=2d3f488a&scoped=true"
import script from "./Badges.vue?vue&type=script&lang=ts"
export * from "./Badges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f488a",
  null
  
)

export default component.exports